import type { FaireProductEntity } from "../../entity_types/product";

export const p_huyu4q26vz: FaireProductEntity = {
  token: "p_huyu4q26vz",
  type: "product",
  name: "rocky’s matcha Houjicha 1kg",
  brandToken: "b_jkddc7grcu",
  brandName: "rocky's matcha",
  imageUrl: "https://cdn.faire.com/fastly/8c47c2240d66a3a6a0d7faedfb333e7fd8d4eab058150aa4400ec11efd16aae3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bcf8defb6b81a34fe6e506555d01e9936c4af5a073afd3eabc276d570e582ebc.jpeg",
    "https://cdn.faire.com/fastly/19a2e2407aa0c89782d9a176893779453db4688c92508d7dcf75d795db1f7494.jpeg"
  ],
  priceDollars: 200,
  description: "rocky's matcha is thrilled to offer our signature blend of houjicha from award winning producer, Mr. Kiyoharu Tsuji. Houjicha, sometimes spelled as \"hojicha\" is a roasted green tea that contains less caffeine than sencha or matcha. Our signature houjicha uses stems and leaves from Tsujiki's tencha and is slow roasted at a relatively low temperature to preserve the flavor and taste of the tea.\n\n• Houjicha\n\n• Region: Uji, Japan\n\n• Net Weight: 1kg",
  tags: [],
  msrpDollars: 400,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:21.868Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
